import { AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';

export function dominioValidador(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const email = control.value as string;
    const domainPattern = /@.+\..+$/;
    return email && !domainPattern.test(email)
      ? { domainRequired: true }
      : null;
  };
}
